// @flow
import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { signupNewsletter } from '../../actions/forms'
import NewsletterForm from '../NewsletterForm'
import FollowButtons from '../FollowButtons'

const VideoWrap = styled.div`
  position: relative;
  height: 0;
  padding-bottom: 56.25%;
  margin-bottom: ${(props) => (props.modal ? '2rem' : '4rem')};
`

const Iframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

const Fancy = styled.span`
  font-weight: bold;
  font-style: italic;
  display: block;
`

type Props = {
  modal?: boolean,
  signupNewsletter: Function
}

const WelcomeContent = (
  { signupNewsletter, modal }: Props // eslint-disable-line
) => (
  <div>
    <div style={{ maxWidth: '600px', margin: 'auto' }}>
      <VideoWrap modal={modal}>
        <Iframe
          frameBorder="0"
          allowFullScreen
          src="https://player.vimeo.com/video/204731002?autoplay=1"
        />
      </VideoWrap>
    </div>
    <div className="row">
      <div className={`${modal ? '' : 'col-md-6'} col-xs-12`}>
        <div style={{ marginBottom: '2rem' }}>
          <Fancy style={{ marginBottom: '1rem' }}>
            Sign up to join our VIP contact group
          </Fancy>
          <NewsletterForm onSubmit={signupNewsletter} />
        </div>
      </div>
      <div className={`${modal ? '' : 'col-md-6'} col-xs-12`}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Fancy style={{ marginRight: '2rem' }}>
            Follow us on social media
          </Fancy>
          <FollowButtons />
        </div>
      </div>
    </div>
  </div>
)

export default connect(
  null,
  { signupNewsletter }
)(WelcomeContent)



// WEBPACK FOOTER //
// ./src/components/WelcomeContent/index.js